/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Row, Col, Space } from 'antd'
import { MediosChart } from './components/MediosChart'
import { PlotMenu } from './components/PlotMenu'

import 'antd/dist/antd.min.css'
import moment from 'moment'

function App () {
  // { x: '01:42', y: 55.87053605435728 }, { x: '01:42', y: 44.12946394564272 },
  // States
  const [totalData, setTotalData] = useState({
    datasets: [{ data: [] }, { data: [] }],
    labels: []
  })
  const [chartData, setChartData] = useState({
    datasets: [{ data: [] }, { data: [] }],
    labels: []
  })
  const [options, setOptions] = useState({})

  const [width, setWindowWidth] = useState(0)
  const [resizeVars, setResizeVars] = useState(true)
  const [timeAct, setTimeAct] = useState('')

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
  }

  useEffect(() => {
    const getDatos = async () => {
      const nombreArchivo = 'data.json'
      const res = await fetch(
        `https://d3f9y58q9tnmw8.cloudfront.net/${nombreArchivo}`
      )

      const data = await res.json()
      const image = new Image()
      image.crossOrigin = 'anonymous' // This enables CORS
      image.src =
        'https://d1uww442kixcfq.cloudfront.net/encuestas/imgs/logo2.png'
      setTotalData(data)
      setTimeAct(data.date_act)

      const data2V = { 'Gabriel Boric': [{ x: '18:31', y: 64.57858179556293 }, { x: '18:41', y: 53.44229900393949 }, { x: '18:51', y: 53.38665400775001 }, { x: '19:01', y: 54.11917722948788 }, { x: '19:11', y: 54.71639751734856 }, { x: '19:21', y: 55.18308779403775 }, { x: '19:31', y: 55.51981274908624 }, { x: '19:41', y: 55.731243837434555 }, { x: '19:51', y: 55.813316000430056 }, { x: '20:01', y: 55.85281518340379 }, { x: '20:11', y: 55.86164528992492 }, { x: '20:21', y: 55.86155157094815 }, { x: '20:31', y: 55.85770784907628 }, { x: '20:41', y: 55.86143765191114 }, { x: '20:51', y: 55.862241755994425 }, { x: '21:01', y: 55.861561124645064 }, { x: '21:11', y: 55.86678421631978 }, { x: '21:21', y: 55.86611858009133 }, { x: '21:31', y: 55.86712887495094 }, { x: '21:41', y: 55.8668425918116 }, { x: '21:51', y: 55.86937698678509 }, { x: '22:01', y: 55.86978710915076 }, { x: '22:11', y: 55.86768919640964 }, { x: '22:21', y: 55.86730848927902 }, { x: '22:31', y: 55.86774690415442 }, { x: '22:41', y: 55.86774690415442 }, { x: '22:51', y: 55.8672621845916 }, { x: '23:01', y: 55.8672621845916 }, { x: '23:11', y: 55.8672621845916 }, { x: '23:21', y: 55.8672621845916 }, { x: '23:31', y: 55.8672621845916 }], 'José Antonio Kast': [{ x: '18:31', y: 35.421418204437074 }, { x: '18:41', y: 46.55770099606051 }, { x: '18:51', y: 46.61334599225 }, { x: '19:01', y: 45.88082277051212 }, { x: '19:11', y: 45.283602482651446 }, { x: '19:21', y: 44.81691220596225 }, { x: '19:31', y: 44.48018725091376 }, { x: '19:41', y: 44.268756162565445 }, { x: '19:51', y: 44.18668399956994 }, { x: '20:01', y: 44.14718481659621 }, { x: '20:11', y: 44.13835471007508 }, { x: '20:21', y: 44.13844842905185 }, { x: '20:31', y: 44.142292150923716 }, { x: '20:41', y: 44.138562348088854 }, { x: '20:51', y: 44.13775824400558 }, { x: '21:01', y: 44.138438875354936 }, { x: '21:11', y: 44.13321578368023 }, { x: '21:21', y: 44.13388141990867 }, { x: '21:31', y: 44.132871125049064 }, { x: '21:41', y: 44.13315740818841 }, { x: '21:51', y: 44.1306230132149 }, { x: '22:01', y: 44.130212890849236 }, { x: '22:11', y: 44.132310803590364 }, { x: '22:21', y: 44.13269151072098 }, { x: '22:31', y: 44.13225309584558 }, { x: '22:41', y: 44.13225309584558 }, { x: '22:51', y: 44.13273781540839 }, { x: '23:01', y: 44.13273781540839 }, { x: '23:11', y: 44.13273781540839 }, { x: '23:21', y: 44.13273781540839 }, { x: '23:31', y: 44.13273781540839 }], labels: ['18:00', '18:01', '18:02', '18:03', '18:04', '18:05', '18:06', '18:07', '18:08', '18:09', '18:10', '18:11', '18:12', '18:13', '18:14', '18:15', '18:16', '18:17', '18:18', '18:19', '18:20', '18:21', '18:22', '18:23', '18:24', '18:25', '18:26', '18:27', '18:28', '18:29', '18:30', '18:31', '18:32', '18:33', '18:34', '18:35', '18:36', '18:37', '18:38', '18:39', '18:40', '18:41', '18:42', '18:43', '18:44', '18:45', '18:46', '18:47', '18:48', '18:49', '18:50', '18:51', '18:52', '18:53', '18:54', '18:55', '18:56', '18:57', '18:58', '18:59', '19:00', '19:01', '19:02', '19:03', '19:04', '19:05', '19:06', '19:07', '19:08', '19:09', '19:10', '19:11', '19:12', '19:13', '19:14', '19:15', '19:16', '19:17', '19:18', '19:19', '19:20', '19:21', '19:22', '19:23', '19:24', '19:25', '19:26', '19:27', '19:28', '19:29', '19:30', '19:31', '19:32', '19:33', '19:34', '19:35', '19:36', '19:37', '19:38', '19:39', '19:40', '19:41', '19:42', '19:43', '19:44', '19:45', '19:46', '19:47', '19:48', '19:49', '19:50', '19:51', '19:52', '19:53', '19:54', '19:55', '19:56', '19:57', '19:58', '19:59', '20:00', '20:01', '20:02', '20:03', '20:04', '20:05', '20:06', '20:07', '20:08', '20:09', '20:10', '20:11', '20:12', '20:13', '20:14', '20:15', '20:16', '20:17', '20:18', '20:19', '20:20', '20:21', '20:22', '20:23', '20:24', '20:25', '20:26', '20:27', '20:28', '20:29', '20:30', '20:31', '20:32', '20:33', '20:34', '20:35', '20:36', '20:37', '20:38', '20:39', '20:40', '20:41', '20:42', '20:43', '20:44', '20:45', '20:46', '20:47', '20:48', '20:49', '20:50', '20:51', '20:52', '20:53', '20:54', '20:55', '20:56', '20:57', '20:58', '20:59', '21:00', '21:01', '21:02', '21:03', '21:04', '21:05', '21:06', '21:07', '21:08', '21:09', '21:10', '21:11', '21:12', '21:13', '21:14', '21:15', '21:16', '21:17', '21:18', '21:19', '21:20', '21:21', '21:22', '21:23', '21:24', '21:25', '21:26', '21:27', '21:28', '21:29', '21:30', '21:31', '21:32', '21:33', '21:34', '21:35', '21:36', '21:37', '21:38', '21:39', '21:40', '21:41', '21:42', '21:43', '21:44', '21:45', '21:46', '21:47', '21:48', '21:49', '21:50', '21:51', '21:52', '21:53', '21:54', '21:55', '21:56', '21:57', '21:58', '21:59', '22:00', '22:01', '22:02', '22:03', '22:04', '22:05', '22:06', '22:07', '22:08', '22:09', '22:10', '22:11', '22:12', '22:13', '22:14', '22:15', '22:16', '22:17', '22:18', '22:19', '22:20', '22:21', '22:22', '22:23', '22:24', '22:25', '22:26', '22:27', '22:28', '22:29', '22:30', '22:31', '22:32', '22:33', '22:34', '22:35', '22:36', '22:37', '22:38', '22:39', '22:40', '22:41', '22:42', '22:43', '22:44', '22:45', '22:46', '22:47', '22:48', '22:49', '22:50', '22:51', '22:52', '22:53', '22:54', '22:55', '22:56', '22:57', '22:58', '22:59', '23:00', '23:01', '23:02', '23:03', '23:04', '23:05', '23:06', '23:07', '23:08', '23:09', '23:10', '23:11', '23:12', '23:13', '23:14', '23:15', '23:16', '23:17', '23:18', '23:19', '23:20', '23:21', '23:22', '23:23', '23:24', '23:25', '23:26', '23:27', '23:28', '23:29', '23:30', '23:31', '23:32', '23:33', '23:34', '23:35', '23:36', '23:37', '23:38', '23:39', '23:40', '23:41', '23:42', '23:43', '23:44', '23:45', '23:46', '23:47', '23:48', '23:49', '23:50', '23:51', '23:52', '23:53', '23:54', '23:55', '23:56', '23:57', '23:58', '23:59'] }

      setOptions({
        responsive: true,
        layout: {
          padding: {
            right: function (ctx) {
              if (ctx.chart.width < 800) {
                return 5
              }
              return 20
            },
            top: function (ctx) {
              if (ctx.chart.width < 800) {
                return 20
              }
              return 40
            }
          }
        },
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: 'top',
            align: 'start'
          },
          title: {
            display: false,
            text: 'En vivo Elecciones'
          },
          tooltip: {
            callbacks: {
              label: function (item) {
                return `${item.dataset.label}: ${item.raw.y.toFixed(2)}%`
              }
            }
          }
        },
        scales: {
          x: {
            ticks: {
              maxTicksLimit: function (ctx) {
                const widthTicks = ctx.chart.width
                if (widthTicks < 800) {
                  return 10
                } else {
                  return 15
                }
              },
              maxRotation: 0,
              minRotation: 0,
              font: function (context) {
                const widthFont = context.chart.width
                const size = 8 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            },
            grid: {
              display: false,
              drawBorder: true,
              drawOnChartArea: false,
              drawTicks: true,
              borderColor: 'black'
            },
            title: {
              display: true,
              text: 'Hora',
              font: function (context) {
                const widthFont = context.chart.width
                const size = 10 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            }
          },
          y: {
            min: 0,
            max: 100,
            ticks: {
              beginAtZero: true,
              stepSize: 10,
              callback: function (value) {
                return `${value}%`
              },
              font: function (context) {
                const widthFont = context.chart.width
                const size = 8 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            },
            grid: {
              display: true,
              drawBorder: true,
              borderColor: 'black'
            },
            title: {
              display: true,
              text: 'Porcentaje',
              font: function (context) {
                const widthFont = context.chart.width
                const size = 10 + Math.round(widthFont / 300)
                return {
                  size
                }
              }
            }
          }
        },
        img_decidechile: image
      })

      setChartData({
        labels: data2V.labels,
        datasets: [
          {
            label: 'Gabriel Boric',
            id: 'gabriel_boric',
            backgroundColor: 'rgba(182, 182, 182, 1)',
            borderColor: 'rgba(182, 182, 182, 1)',
            borderWidth: 3,
            tension: 0.4,
            data: data2V['Gabriel Boric'],
            pointStyle: 'circle',
            pointRadius: 2,
            pointHoverRadius: 4,
            hidden: false,
            yAxisID: 'y'
          },
          {
            label: 'José Antonio Kast',
            id: 'jose_antonio_kast',
            backgroundColor: 'rgba(0, 0, 0, 1)',
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: 3,
            data: data2V['José Antonio Kast'],
            pointStyle: 'circle',
            pointRadius: 2,
            pointHoverRadius: 4,
            hidden: false,
            tension: 0.4,
            yAxisID: 'y'
          },
          {
            label: 'Apruebo',
            id: 'apruebo',
            backgroundColor: 'rgba(0, 169, 209, 1)',
            borderColor: 'rgba(0, 169, 209, 1)',
            borderWidth: 3,
            data: data.apruebo,
            pointStyle: 'circle',
            pointRadius: 2,
            pointHoverRadius: 4,
            hidden: false,
            tension: 0.4,
            yAxisID: 'y'
          },
          {
            label: 'Rechazo',
            id: 'rechazo',
            backgroundColor: 'rgba(255, 58, 59, 1)',
            borderColor: 'rgba(255, 58, 59, 1)',
            borderWidth: 3,
            data: data.rechazo,
            pointStyle: 'circle',
            pointRadius: 2,
            pointHoverRadius: 4,
            hidden: false,
            tension: 0.4,
            yAxisID: 'y'
          }
        ]
      })
    }
    getDatos()
    updateDimensions()

    setInterval(() => {
      getDatos()
    }, 60000)

    window.addEventListener('resize', updateDimensions)

    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  // UseEffect para cambiar variables cuando grafico sea pequeño
  useEffect(() => {
    if (resizeVars === true) {
      setChartData(c => {
        return {
          ...c,
          datasets: [
            { ...c.datasets[0], pointRadius: 2, pointHoverRadius: 4 },
            { ...c.datasets[1], pointRadius: 2, pointHoverRadius: 4 },
            { ...c.datasets[2], pointRadius: 2, pointHoverRadius: 4 },
            { ...c.datasets[3], pointRadius: 2, pointHoverRadius: 4 }
          ]
        }
      })
    } else {
      setChartData(c => {
        return {
          ...c,
          datasets: [
            { ...c.datasets[0], pointRadius: 1, pointHoverRadius: 3 },
            { ...c.datasets[1], pointRadius: 1, pointHoverRadius: 3 },
            { ...c.datasets[2], pointRadius: 1, pointHoverRadius: 3 },
            { ...c.datasets[3], pointRadius: 1, pointHoverRadius: 3 }
          ]
        }
      })
    }
  }, [resizeVars])

  // UseEffect para señalar si se ha achicado o agrandado el grafico
  useEffect(() => {
    setResizeVars(prevResize => {
      if (width < 600 && prevResize === true) {
        return false
      } else if (width > 600 && prevResize === false) {
        return true
      } else {
        return prevResize
      }
    })
  }, [width])

  return (
    <div className="App">
      <Space direction="vertical" size={2} style={{ display: 'flex' }}>
        <Row>
          <Col xs={{ span: 20, offset: 4 }} lg={{ span: 20, offset: 2 }}>
            <PlotMenu
            />
          </Col>
        </Row>

        <Row>
          <Col xs={{ span: 22, offset: 1 }} lg={{ span: 21, offset: 1 }}>
            {Object.keys(options).length > 0
              ? (
              <MediosChart chartData={chartData} options={options} />
                )
              : (
              <div />
                )}
          </Col>
        </Row>

        <Row>
          <Col xs={{ span: 22, offset: 1 }} lg={{ span: 20, offset: 2 }}>
            <p>Última Actualización: {timeAct}</p>
          </Col>
        </Row>
      </Space>
    </div>
  )
}

export default App
